import { useNavigate, Link } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { logout } from '../services/AuthService';
import './console-navbar.css';
import { NavLink } from 'react-router-dom';
import './navbar.css';
import { useState, useEffect } from 'react';
import { subscriptionInfo } from '../api';
import logo from '../assets/img/AccessEVAEnterprise.jpg';
import logo_accesseva from '../assets/img/AccessEVA.jpg';

function ConsoleNavbar({ onFeedbackShow }) {
  const [isPaid, setIsPaid] = useState(false);

  const items = [
    { path: '/console/Projects', title: 'Projects' },
    { path: '/console/resources', title: 'Resources' },
    /*    { path: '/console/docfile', title: 'DocFile' }, */
    // { path: '/console/Chatbot', title: 'New Interaction' },
  ];

  const navigate = useNavigate();
  const auth = useAuth();
  const user = auth.getSession();
  const [isEnterpriseUser, setIsEnterpriseUser] = useState(false);
  const org = localStorage.getItem('org') || "";
  const isAdmin = auth.isAdminAuth();
  const isOrgAdmin = auth.isOrgAdminAuth();

  const handleLogout = async (e) => {
    e.preventDefault();

    await logout();
    navigate('/');
  };

  const handleFeedbackShow = (e) => {
    e.preventDefault();
    onFeedbackShow();
  };


  useEffect(() => {
    fetchSubscriptionInfo();
  }, []);

  const fetchSubscriptionInfo = async () => {
    try {
      const response = await subscriptionInfo();
      const data = response.data;
      setIsPaid(data.is_paid)
      setIsEnterpriseUser(user.is_enterprise);
    } catch (error) {
      console.error('Error fetching subscription price:', error);
    }
  };

  return (
    <div className='sticky-top'>
      {org && <nav className="navbar navbar-expand-md bg-body-secondary py-0 px-2">
        <div className="container-fluid">
          <Link
            to="/console"
            className="navbar-brand fs-6 fw-bold text-muted"
          >
            {org}
          </Link>
        </div>
      </nav>
      }
      <nav className="navbar navbar-expand-md navbar-light bg-white sticky-top p-0 pt-1 border-bottom">
        <div className="container-fluid d-flex flex-grow-1 ps-2">
          <Link to="/" className="navbar-brand fw-bold p-0 my-0">
            {org ? (
              logo && (
                <img
                  src={logo}
                  alt="Organization Logo"
                  style={{ height: "46px" }}
                  className="img-fluid px-0 my-0"
                />
              )
            ) : (
              logo_accesseva && (
                <img
                  src={logo_accesseva}
                  alt="AccessEva Logo"
                  style={{ height: "46px" }}
                  className="img-fluid px-0 my-0"
                />
              )
            )}
          </Link>
          <button className="navbar-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarMenu"
            aria-controls="navbarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarMenu">
            <ul className="navbar-nav ms-auto mb-2 mb-md-0 flex-nowrap">
              {
                items.map((item, i) => (
                  <li key={i} className="nav-item">
                    <NavLink className="nav-link link-primary text-nowrap" to={item.path}>{item.title}</NavLink>
                  </li>
                ))
              }
              {isEnterpriseUser && (
                <li className="nav-item">
                  <NavLink className="nav-link link-primary text-nowrap" to='/console/questionsets'>Query Sets</NavLink>
                </li>
              )}
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle link-primary" data-bs-toggle="dropdown" onClick={(e) => e.preventDefault()} aria-expanded="false"> {user.firstname} {user.lastname} </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <NavLink className="dropdown-item" to='/console/profile'>Account</NavLink>
                  </li>

                  {!org &&
                    <li>
                      <NavLink className="dropdown-item" to='/console/payment'>Payment</NavLink>
                    </li>
                  }
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  {(isAdmin || isOrgAdmin) && (
                    <>
                      <li>
                        <NavLink className="dropdown-item" to='/admin/users'>Admin Dashboard</NavLink>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                    </>
                  )}

                  <li><button className="dropdown-item" onClick={handleLogout}>Log Out</button></li>
                </ul>
              </li>
              {!isPaid && !org &&
                <li className="nav-item me-2">
                  <NavLink className="btn btn-success" to='/console/services' style={{ whiteSpace: 'nowrap' }}>Subscribe Now</NavLink>
                </li>
              }
              <li className="nav-item me-2">
                <NavLink className="btn btn-success" to='/console/guide' style={{ whiteSpace: 'nowrap' }}>User Guide</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="btn btn-warning" onClick={handleFeedbackShow}>Feedback</NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default ConsoleNavbar;
